import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from '../components/common/NotFound';
import Header from '../components/header/index.js';
import { withRouter } from 'react-router';
import ScrollToTop from '../components/common/ScrollToTop';
import { StateMachineProvider } from 'little-state-machine';
import AddToHomeScreen from './AddToHomeScreenBanner';
import SidebarMobile from '../components/sideBar/sideBarMobile';
import userRoutes from '../config/users';
import Login from '../components/userAuthentication/Login';
import { Redirect } from 'react-router';
import UserTypes from '../utils/userTypes';
import { connect } from 'react-redux';
import { setUserType } from '../redux/userAuthentication/userAuth.actions';
import { compose } from 'redux';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			online: true,
			userType: 'parent',
		};
		this.setOnlineStatus = this.setOnlineStatus.bind(this);
		// this.getAuthenticatedRoutes = this.getAuthenticatedRoutes.bind(this);
		// this.getRedirected = this.getRedirected.bind(this);
	}

	// Detects if device is in standalone mode

	componentDidMount() {
		window.addEventListener('touchstart', () => {});
		window.addEventListener('touchend', () => {});
		window.addEventListener('touchcancel', () => {});
		window.addEventListener('touchmove', () => {});
		window.addEventListener('online', () => this.setState({ online: true }));
		window.addEventListener('offline', () => this.setState({ online: false }));

		window.scrollTo(0, 1);
	}

	setOnlineStatus(isOnline) {
		this.setState({ online: isOnline });
	}

	componentWillUnmount() {
		window.removeEventListener('online', () => this.setOnlineStatus(false));
		window.removeEventListener('offline', () => this.setOnlineStatus(false));
	}

	render() {
		// Detects if device is on iOS
		const { online } = this.state;
		const pageTypes = [
			'/',
			'/logout',
			'/signup',
			'/parent/signup',
			'/parent/login',
			'/parent/verifyotp',
			'/junior/signin',
			'/verifyuser',
			'/test',
			'/sso',
			'/paymentsuccess',
			'/paymentfailure',
			'/paymentprocesss',
		];
		const { location, userType, setUserType } = this.props;
		return (
			<div>
				<StateMachineProvider>
					<ScrollToTop />
					{pageTypes.indexOf(location.pathname.toLowerCase()) < 0 &&
						!(
							location.pathname.toLowerCase() === '/purchase' &&
							localStorage.getItem('sso') === '0'
						) &&
						(window.outerWidth > 768 ? <Header /> : <SidebarMobile />)}
					<Switch>
						{userType === UserTypes.Regular || userType === UserTypes.Parent ? (
							[
								userRoutes.regularUser.routes.map((route, index) => (
									<Route
										key={index}
										path={route.path}
										render={() => {
											if (userType === UserTypes.Parent) {
												setUserType(UserTypes.Regular);
											}
											return localStorage.getItem('paymentInProcess') === '1' &&
												localStorage.getItem('referer') === 'landing' ? (
												<Redirect to={{ pathname: '/logout' }} />
											) : localStorage.getItem('token') ? (
												route.component
											) : (
												<Redirect
													to={{
														pathname: '/',
														search: `?return_path=${window.location.pathname}${window.location.search}`,
														state: { from: window.location.pathname },
													}}
												/>
											);
										}}
										exact={route.exact}
									/>
								)),
								userRoutes.parent.routes.map((route, index) => (
									<Route
										key={index}
										path={route.path}
										render={() => {
											if (userType === UserTypes.Regular) {
												setUserType(UserTypes.Parent);
											}
											return localStorage.getItem('paymentInProcess') === '1' &&
												localStorage.getItem('referer') === 'landing' ? (
												<Redirect to={{ pathname: '/logout' }} />
											) : localStorage.getItem('token') ? (
												route.component
											) : (
												<Redirect
													to={{
														pathname: '/parent/signin',
														search: `?return_path=${window.location.pathname}${window.location.search}`,
														state: { from: window.location.pathname },
													}}
												/>
											);
										}}
										exact={route.exact}
									/>
								)),
							]
						) : userType === UserTypes.Junior ? (
							userRoutes.junior.routes.map((route, index) => (
								<Route
									key={index}
									path={route.path}
									component={() =>
										localStorage.getItem('paymentInProcess') === '1' &&
										localStorage.getItem('referer') === 'landing' ? (
											<Redirect to={{ pathname: '/logout' }} />
										) : localStorage.getItem('token') ? (
											route.component
										) : (
											<Redirect
												to={{
													pathname: '/junior/signin',
													search: `?return_path=${window.location.pathname}${window.location.search}`,
													state: { from: window.location.pathname },
												}}
											/>
										)
									}
									exact={route.exact}
								/>
							))
						) : (
							<Route path="/" component={Login} exact={true} />
						)}

						{userRoutes.auth.routes.map((route, index) => (
							<Route
								key={index}
								path={route.path}
								component={route.component}
								exact={route.exact}
							/>
						))}
						{userRoutes.payment.routes.map((route, index) => (
							<Route
								key={index}
								path={route.path}
								component={() =>
									localStorage.getItem('token') ? (
										route.component
									) : (
										<Redirect
											to={{
												pathname: '/',
												search: `?return_path=${window.location.pathname}${window.location.search}`,
												state: { from: window.location.pathname },
											}}
										/>
									)
								}
								exact={route.exact}
							/>
						))}

						{userRoutes.common.routes.map((route, index) => (
							<Route
								key={index}
								path={route.path}
								component={() =>
									localStorage.getItem('paymentInProcess') === '1' &&
									localStorage.getItem('referer') === 'landing' ? (
										<Redirect to={{ pathname: '/logout' }} />
									) : localStorage.getItem('token') ? (
										route.component
									) : (
										<Redirect
											to={{
												pathname: '/',
												search: `?return_path=${window.location.pathname}${window.location.search}`,
												state: { from: window.location.pathname },
											}}
										/>
									)
								}
								exact={route.exact}
							/>
						))}

						{userType === UserTypes.Junior &&
						(userRoutes.regularUser.routes.filter((x) =>
							x.path.includes(window.location.pathname),
						).length > 0 ||
							userRoutes.parent.routes.filter((x) =>
								x.path.includes(window.location.pathname),
							).length > 0) ? (
							<Redirect
								to={{
									pathname: '/junior/dashboard',
								}}
							/>
						) : (
							<Route component={NotFound} />
						)}
					</Switch>
				</StateMachineProvider>

				{!online ? (
					<AddToHomeScreen message={'App is Offline'} isError={true} />
				) : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { userType } = state.rootReducer.loginDetails;
	return {
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(App),
);
